import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import closeIcon from '../assets/images/cross-close.svg';
import plusBlueIcon from '../assets/images/plus_blue.svg';
import trashIcon from '../assets/images/trash.svg';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from 'rsuite';
import dayjs from 'dayjs';
import { seteventdetail } from '../features/CreateEventDetailSlice';
import { clearDuplicateTimeSlots, setDuplicateTimeSlots } from '../features/DuplicateTimeSlotSlice';

export const DuplicateSlotSpecificeDate = ({ handleClose, callBackClickHandlerNext, backButtonClickHandler }) => {

    const [duplicateSlots, setDuplicateSlots] = useState([]);
    const [startingOnDate, setStartingOnDate] = useState(null);
    const [endingOnDate, setEndingOnDate] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectSpecificeDate, setSelectSpecificeDate] = useState(null);
    const [currentDayRowdetail, setCurrentDayRowdetail] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxEventDetail = useSelector(state => state.eventDetail.eventDetail);
    const reduxDuplicateTimeSlots = useSelector(state => state.duplicateTimeSlots.duplicateTimeSlots);
    const reduxScheduleTimeSlotsDetail = useSelector(state => state.scheduleTimeSlotsDetail.scheduleTimeSlotsDetail);
    const dispatch = useDispatch();

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
    const generateId = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

    const DuplicateDateObj = {
        id: generateId(),
        day: "",
        durationSlotsRow: [1],
        weekDay: 6,
        specificeDatePickter: null,
        duplicateTimePicker: [{ id: generateId(), startTime: "", endTime: "" }]
    }

    const handleAddNewDateForDuplicateSlot = () => {
        setErrorMessage("");
        setDuplicateSlots([...duplicateSlots, DuplicateDateObj]);
    }

    useEffect(() => {
        if (reduxEventDetail && reduxEventDetail.timeSlots) {
            setTimeSlots(structuredClone(reduxEventDetail.timeSlots));
        }
    }, [reduxEventDetail]);


    const addNewSlotDurationRow = (index) => {

        // new time slot add into correct or select obj
        let rowData;
        if (currentDayRowdetail != null) {
             rowData =  currentDayRowdetail[0]
        } else {
            const allDuplicateSlots = duplicateSlots[index];
            const filterCurrentDayClickTimeSlot = timeSlots.filter((item) => item.day == allDuplicateSlots.day);
            rowData = filterCurrentDayClickTimeSlot[0];
        }

        let slotDuration = +reduxEventDetail.event.EventDuration;

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day && item.endTimes.length > 0) {

                //get last element of start time and end time of current duration row
                let lastElementEndTimes = item.endTimes[item.endTimes.length - 1];
                let length = item.endTimes.length;

                //convert duration to milliseconds
                let minutesToAdd = slotDuration * 60000;

                //get last row start and end time of current duration row
                item.startTimes.push({ field: item.day + 'From' + length + 1, date: lastElementEndTimes.date });

                //add minutes
                let endDateToSet = new Date(lastElementEndTimes.date);
                endDateToSet.setTime(endDateToSet.getTime() + minutesToAdd);

                //push final element to start and end times arrays of selected duration row
                item.endTimes.push({ field: item.day + 'To' + length + 1, date: endDateToSet });
                item.durationSlotsRows.push(item.durationSlotsRows.length + 1);

                const subTimePickterObj = { id: generateId(), startTime: lastElementEndTimes.date, endTime: endDateToSet };
                const updatedSlots = [...duplicateSlots];
                /*updatedSlots[index].durationSlotsRow.push(updatedSlots[index].durationSlotsRow.length + 1);*/
                updatedSlots[index].duplicateTimePicker.push(subTimePickterObj);
                /*console.log(updatedSlots);*/
                setDuplicateSlots(updatedSlots);
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
    }

    // Delete time slots method
    const deleteSlotRow = (parentId, childId, identifiction, parentIndex, day) => {

        if (identifiction == "parent") {

            // remove specifice date obj from ui
            const removeParent = duplicateSlots.filter((item) => item.id != parentId);
            setDuplicateSlots(removeParent);

            // remove and update timeSlot obj "obj adnan sir"
            let updatedTimeSlots = timeSlots.map(item => {
                if (day == item.day) {
                    item.startTimes = [];
                    item.endTimes = [];
                    item.durationSlotsRows = [1];
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);

        } else if (identifiction == "child") {

            // find the index of row
            const indexOfRow = duplicateSlots[parentIndex].duplicateTimePicker.findIndex(slotId => slotId.id == childId);

            // remove the slot time  "obj adnan sir"
            let updatedTimeSlots = timeSlots.map(item => {
                if (day == item.day) {
                    item.startTimes.splice(indexOfRow, 1);
                    item.endTimes.splice(indexOfRow, 1);
                    item.durationSlotsRows.splice(indexOfRow, 1);
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);

            // remove object from ui json 
            const removeSubTimeSlotAndUpdate = duplicateSlots.map(slot => {
                if (slot.id == parentId) {

                    const updatedDurationSlotsRow = [...slot.durationSlotsRow];
                    updatedDurationSlotsRow.splice(indexOfRow, 1);

                    return {
                        ...slot,
                        durationSlotsRow: updatedDurationSlotsRow,
                        duplicateTimePicker: slot.duplicateTimePicker.filter((item) => item.id != childId)
                    }
                }
                return slot;
            })
            setDuplicateSlots(removeSubTimeSlotAndUpdate);
        }
        return;
    }

    const setStartTime = (val, parentIndex, timePickterIndex) => {

        let time = dayjs(val).format("HH:mm");
        let day;
        let Id;
        setErrorMessage("");

        if (selectSpecificeDate != undefined && selectSpecificeDate != null) {
            day = dayjs(selectSpecificeDate).day();
        } else {
            let currentDateSelectDay = duplicateSlots[parentIndex].day
            day = days.indexOf(currentDateSelectDay);
        }

        // get select day
        const selectDay = days[day];

        const filterTimeSlotOnDay = timeSlots.filter(item => item.day == selectDay);
       /* console.log(filterTimeSlotOnDay);*/

        var rowData = filterTimeSlotOnDay[0] //hoursItem; //JSON.parse(e.target.getAttribute("durationitem"));
        let elementId = day + "To" + rowData.durationSlotsRows.length;

        let splittedTime = time.split(":");
        let timeArray = splittedTime.map(item => { return +item });

        let date = new Date();
        let currentDay = date.getDay();

        let distance = (rowData.weekDay || days.length) - currentDay;
        if (distance < 0) {
            date.setDate(date.getDate() + distance + 7);
        }
        else {
            date.setDate(date.getDate() + distance);
        }
        date.setHours(timeArray[0]);
        date.setMinutes(timeArray[1]);

        let startDateTime = new Date(date);
        let slotDuration = +reduxEventDetail.event.EventDuration;
        startDateTime.setMinutes(startDateTime.getMinutes() + slotDuration);

        if (startDateTime.getDate() > date.getDate()) {
            document.querySelector("#" + rowData.day + "From" + rowData.durationSlotsRows.length).parentNode.style.borderColor = "red";
            let message = reduxLanguageTranslations ? (reduxLanguageTranslations["invalidStartTimeErrorMessage"] + ": " + slotDuration) : ("Invalid Start Time! because end time will cross midnight time as slot duration is: " + slotDuration);
            //setTimeSlotValidationMessage(message);
        }

        let updatedTimeSlots = timeSlots.map(item => {
            if (selectDay == item.day) {

                let indexExist = -1;
                item.startTimes.forEach((item, i) => {
                    if (item.field == Id) {
                        indexExist = i;
                    }
                })
                let timeObj = { field: Id, date: date }
                if (indexExist == -1) {
                    item.startTimes.push(timeObj);
                }
                else {
                    item.startTimes[indexExist] = timeObj
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
        setEndTime(elementId, date, rowData, parentIndex, timePickterIndex);
    }

    const setEndTime = (elementId, date, rowData, parentIndex, timePickterIndex) => {

        let endDate = new Date(date);
        let minutesToAdd = +reduxEventDetail.event.EventDuration
        endDate.setMinutes(endDate.getMinutes() + minutesToAdd);
        let hours = endDate.getHours() < 10 ? "0" + endDate.getHours() : endDate.getHours();
        let minutes = endDate.getMinutes() < 10 ? "0" + endDate.getMinutes() : endDate.getMinutes();
        var time = hours + ":" + minutes;

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {

                let indexExist = -1;
                item.endTimes.forEach((eTime, i) => {
                    if (eTime.field == elementId) {
                        indexExist = i;
                    }
                })
                let timeObj = { field: elementId, date: endDate }
                if (indexExist == -1) {
                    item.endTimes.push(timeObj);
                }
                else {
                    item.endTimes[indexExist] = timeObj
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);

        // update the object values startTime and endTime
        const filterTimeSlotWithDay = updatedTimeSlots.filter(item => item.day == rowData.day);
        duplicateSlots[parentIndex].duplicateTimePicker[timePickterIndex].startTime = filterTimeSlotWithDay[0].startTimes[0].date;
        duplicateSlots[parentIndex].duplicateTimePicker[timePickterIndex].endTime = filterTimeSlotWithDay[0].endTimes[0].date;
        duplicateSlots[parentIndex].day = filterTimeSlotWithDay[0].day;
        setCurrentDayRowdetail(filterTimeSlotWithDay);
    }

    useEffect(() => {
        let slotArray = [];
        let mondayIndex = 1; // Index of Monday in the days array

        for (let i = 0; i < 7; i++) {
            // Calculate the day index in the original days array, wrapping around using modulo
            let dayIndex = (mondayIndex + i) % 7;
            let currentDay = days[dayIndex]; // Get the day name (Mon, Tue, etc.)

            slotArray.push({
                day: currentDay,
                weekDay: dayIndex, // Weekday index corresponding to the original array
                durationSlotsRows: [1],
                startTimes: [],
                endTimes: [],
                isChecked: true,
                isOkButtonVisible: false
            });
        }

        if (reduxEventDetail && reduxEventDetail.timeSlots == null) {
            setTimeSlots(slotArray);
        }

        if (reduxDuplicateTimeSlots != null) {
            const formatted = reduxDuplicateTimeSlots.map((item) => ({
                ...item,
                specificeDatePickter: dayjs(item.specificeDatePickter), // mui date format 
                duplicateTimePicker: item.duplicateTimePicker.map((slot) => ({
                    ...slot,
                    startTime: new Date(slot.startTime), // convert date string into date
                    endTime: new Date(slot.endTime),
                })),
            }));
            setDuplicateSlots(formatted);
        } else {
            setDuplicateSlots([DuplicateDateObj]);
        }
        
    }, [])

    const onChangeSpecificeDatePickter = (newDate, index) => {
        setErrorMessage("");
        setSelectSpecificeDate(newDate);
        const updatedSlots = [...duplicateSlots];
        updatedSlots[index].specificeDatePickter = newDate;
        setDuplicateSlots(updatedSlots);
    }

    const handleNextClickBtn = () => {

        const availableHoursArr = [];
        const repeatAvailableHours = [];
        const CreateDuplicateFreeSlot = +reduxScheduleTimeSlotsDetail.duplicateEachSlotDropdown;

        // check validation 
        for (let slot of duplicateSlots) {
            if (!slot.specificeDatePickter) {
                setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateErrorTimeSlotMustHaveDate"]: "Each time slot must have a date");
                return;
            }

            for (let time of slot.duplicateTimePicker) {
                if (!time.startTime || !time.endTime) {
                    setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateErrorTimeSlotMustHaveStartEndDate"] : "Each slot must have a start and end time");
                    return;
                }
            }
        }

        // convert date format into UTC format
        duplicateSlots.forEach((item) => {
            item.duplicateTimePicker.forEach((timeSlot) => {
                const start = new Date(timeSlot.startTime);
                start.setMinutes(start.getMinutes() - start.getTimezoneOffset());

                const end = new Date(timeSlot.endTime);
                end.setMinutes(end.getMinutes() - end.getTimezoneOffset());

                availableHoursArr.push({
                    AllDay: false,
                    Day: item.day,
                    StartDateTime: start.toISOString(), // Correct UTC output
                    EndDateTime: end.toISOString()
                });
            });
        });

        // create duplicate free slot many time according to select user dropdown
        for (let i = 0; i < CreateDuplicateFreeSlot; i++) {
            availableHoursArr.forEach(item => {
                repeatAvailableHours.push({ ...item });
            });
        }

        let eventDetail = {
            event: reduxEventDetail.event,
            availableHours: repeatAvailableHours,
            selectedDateRange: null,
            timeSlots: timeSlots,
            invitee: null,
            confirmEventSlot: null
        };

        dispatch(seteventdetail(eventDetail));
        dispatch(setDuplicateTimeSlots(duplicateSlots));
        callBackClickHandlerNext();
    }

    const backToMoveScheduleTimeSlotModel = () => {

        let eventDetail = {
            event: reduxEventDetail.event,
            availableHours: null,
            selectedDateRange: null,
            timeSlots: null,
            invitee: null,
            confirmEventSlot: null
        };

        dispatch(seteventdetail(eventDetail));
        dispatch(clearDuplicateTimeSlots(null));
        backButtonClickHandler();
    }

 /*   console.log(duplicateSlots);
    console.log(timeSlots);*/

   /* if (selectSpecificeDate) {
        const day = dayjs(selectSpecificeDate).day(); // Day of month (1-31)
        const month = dayjs(selectSpecificeDate).month() + 1; // Month (0-11), so +1
        const hour = dayjs(selectSpecificeDate).hour(); // Hour (0-23)
        const minute = dayjs(selectSpecificeDate).minute(); // Minute (0-59)
        const userDay = days[day];
        console.log({ day, month, hour, minute });
        console.log(userDay);
    }*/

    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <ul className="form-steps">
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar active"></li>
                    <li className="step-bar"></li>
                </ul>
                <img src={closeIcon} onClick={handleClose} className="cursor-pointer" />
            </div>
            <p className="form-title mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["SpecifcDateRadioBtnTxt"] : "Specific dates"}</p>
            {
                duplicateSlots.map((item, parentIndex) => {
                    return (
                        <div key={parentIndex} className="mb-4">
                            <p className="mb-2">Date {parentIndex + 1}</p>
                            <div className="d-flex">
                                <div className="specificeDatePickter-container me-3">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker
                                                value={item.specificeDatePickter}
                                                onChange={(newDate) => onChangeSpecificeDatePickter(newDate, parentIndex)}
                                                format="DD MMMM YYYY"
                                                sx={{ width: 120 }}
                                                slotProps={{
                                                    textField: {
                                                        placeholder: 'dd/mm/yyyy',
                                                    },
                                                }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>

                                <div>
                                    {
                                        item.duplicateTimePicker.map((timeSlotItem, subIndex) => {
                                            return (
                                                <div key={subIndex} className="time-slot-container d-flex justify-content-between mb-2">
                                                    <TimePicker format="HH:mm" className={`me-2`}
                                                        className=""
                                                        id={`${item.day}From1`}
                                                        onChange={(e) => setStartTime(e, parentIndex, subIndex)}
                                                        cleanable={false}
                                                        container={document.body}
                                                        value={timeSlotItem.startTime}
                                                        editable={subIndex == 0 && item.specificeDatePickter != null }
                                                        open={false}
                                                    />
                                                    <TimePicker format="HH:mm" className={`me-2`}
                                                        id={`${item.day}To1`}
                                                        cleanable={false}
                                                        container={document.body}
                                                        value={timeSlotItem.endTime}
                                                        open={false}
                                                        disabled
                                                    />
                                                    <div className="time-slot-btn d-flex align-items-center">
                                                        {
                                                            subIndex == 0 ?
                                                                <>
                                                                    <img src={plusBlueIcon} className="me-1" onClick={item.specificeDatePickter != null && timeSlotItem.startTime != "" ? () => addNewSlotDurationRow(parentIndex) : undefined } />
                                                                    <img src={trashIcon} onClick={() => deleteSlotRow(item.id, timeSlotItem.id, "parent", parentIndex, item.day)} />
                                                                </>
                                                                :
                                                                <img src={trashIcon} onClick={() => deleteSlotRow(item.id, timeSlotItem.id, "child", parentIndex, item.day)} />
                                                         }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }                               
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <hr className="mb-2" />
            <span className="specifceDateAddNewDate-container" onClick={handleAddNewDateForDuplicateSlot}>
                <img src={plusBlueIcon} className="me-2" />
                <span className="duplicate-SpecificDate-addNewSlotBtnText">{reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateAddNewSlotBtnTxt"] : "Back"}</span>
            </span>
            <p className="text-danger my-2">{errorMessage}</p>
            <div className="d-flex mt-4">
                <button type="button" className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" onClick={backToMoveScheduleTimeSlotModel}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBackBtn"] : "Back"}</button>
                <button type="button" className="site-btn site-btn-padd w-100" onClick={handleNextClickBtn}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalNextBtn"] : "Next"}</button>
            </div>
        </>
    )
}
